"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAnySentencesList = exports.isAnySentence = exports.AnySentenceSchema = exports.isAnySentenceWordSentenceWithSentenceWordStatus = exports.AnySentenceWordSentenceWithSentenceWordStatusSchema = exports.isAnySentenceWordSentenceWithSpecialWordData = exports.AnySentenceWordSentenceWithSpecialWordDataSchema = exports.isAnySentenceWordSentence = exports.AnySentenceWordSentenceSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const bootcamp_sentence_types_1 = require("./bootcamp_sentence_types");
const non_special_sentence_types_1 = require("./non_special_sentence_types");
const special_sentence_types_1 = require("./special_sentence_types");
exports.AnySentenceWordSentenceSchema = zod_1.z.union([
    non_special_sentence_types_1.NonSpecialSentenceSchema,
    special_sentence_types_1.SpecialSentenceSchema,
]);
exports.isAnySentenceWordSentence = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceWordSentenceSchema);
exports.AnySentenceWordSentenceWithSpecialWordDataSchema = zod_1.z.union([
    non_special_sentence_types_1.NonSpecialSentenceWithSpecialWordDataSchema,
    special_sentence_types_1.SpecialSentenceWithSpecialWordDataSchema,
]);
exports.isAnySentenceWordSentenceWithSpecialWordData = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceWordSentenceWithSpecialWordDataSchema);
exports.AnySentenceWordSentenceWithSentenceWordStatusSchema = zod_1.z.union([
    non_special_sentence_types_1.NonSpecialSentenceWithSentenceWordStatusSchema,
    special_sentence_types_1.SpecialSentenceWithSentenceWordStatusSchema,
]);
exports.isAnySentenceWordSentenceWithSentenceWordStatus = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceWordSentenceWithSentenceWordStatusSchema);
exports.AnySentenceSchema = zod_1.z.union([
    exports.AnySentenceWordSentenceSchema,
    bootcamp_sentence_types_1.BootcampSentenceSchema,
]);
exports.isAnySentence = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceSchema);
const AnySentencesListSchema = zod_1.z.array(exports.AnySentenceSchema);
const validateAnySentencesList = (x) => AnySentencesListSchema.safeParse(x);
exports.validateAnySentencesList = validateAnySentencesList;
//# sourceMappingURL=sentence_types.js.map